// removed by extract-text-webpack-plugin
module.exports = {"root":"sharing-links__root","title":"sharing-links__title","link":"sharing-links__link"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/sharing-links/styles.less
// module id = 472
// module chunks = 1